/**
 * Query-string serialization for `/dye` events. Mirrors the spirit of yoto-web's
 * `serializeAnalyticsArgs`: skip null/undefined, encode values, preserve insertion
 * order so the resulting URL is stable across reloads.
 */

export type QueryParamValue = string | number | boolean | null | undefined;

export function serializeParams(params: Record<string, QueryParamValue>): string {
  const parts: string[] = [];
  for (const key of Object.keys(params)) {
    const value = params[key];
    if (value === null || value === undefined) continue;
    parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
  }
  return parts.join('&');
}

export function joinUrl(base: string, path: string): string {
  if (!path) return base;
  if (base.endsWith('/') && path.startsWith('/')) return base + path.slice(1);
  if (!base.endsWith('/') && !path.startsWith('/')) return `${base}/${path}`;
  return base + path;
}
